<template>
  <div class="home-container">
    <div class="home-content" v-if="recordFlag">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="标题" prop="title" style="width: 80%">
                <el-input
                  v-model="searchForm.title"
                  placeholder="请输入标题"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="类型" prop="type" style="width: 80%">
                <el-select clearable filterable v-model="searchForm.type" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="ind" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="img" label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          align="center"
          :formatter="typeList"
        >
        </el-table-column>
        <el-table-column prop="praiseCount" label="点赞" align="center">
        </el-table-column>
        <el-table-column
          prop="authority"
          label="发布范围"
          align="center"
          :formatter="authorityList"
        >
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="isTop" label="是否置顶" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isTop"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="查看评论" align="center">
          <template slot-scope="scope">
            <a @click="bindRecord(scope.row.id)">查看评论</a>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <!-- <el-col :span="12">
              <el-form-item label="详情图片" prop="detailImg">
                <upload
                  :url.sync="addData.detailImg"
                  :src="addData.detailImg"
                  type="img"
                  :width="690"
                  :height="260"
                ></upload>
                <div style="color: red">*(建议尺寸690px * 260px)）</div>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="标题" prop="title">
                <el-input
                  placeholder="请输入标题"
                  v-model="addData.title"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类型" prop="type">
                <el-select clearable filterable v-model="addData.type" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发布范围" prop="authority">
                <el-select clearable filterable v-model="addData.authority" placeholder="请选择">
                  <el-option
                    v-for="item in userTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图片" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  :width="220"
                  :height="160"
                ></upload>
                <div style="color: red">*(建议尺寸220px * 160px)）</div>
              </el-form-item>
            </el-col>            
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="内容" prop="content">
                <ueditor v-model="addData.content"></ueditor>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div v-else>
      <commentList :activityId="activityId" @back="back"></commentList>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor";
import commentList from "./components/commentList.vue";
export default {
  components: {
    upload,
    ueditor,
    commentList,
  },
  data() {
    return {
      searchForm: {
        title: "",
        type: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      options: [
        {
          label: "党史学习",
          value: 1,
        },
        {
          label: "公共服务",
          value: 2,
        },
        {
          label: "政务服务",
          value: 3,
        },
      ],
      userTypeList: [
        {
          label: "全部",
          value: -1,
        },
        {
          label: "业主",
          value: 0,
        },
        {
          label: "亲属",
          value: 1,
        },
        {
          label: "租客",
          value: 2,
        },
        {
          label: "普通用户",
          value: 3,
        },
      ],
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img: "",
        detailImg: "",
        title: "",
        type: "",
        authority: "",
        content: "",
      },
      addDataRules: {
        img: [{ required: true, message: "请上传图片", trigger: "blur" }],
        // detailImg: [
        //   { required: true, message: "请上传详情图片", trigger: "blur" },
        // ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        authority: [
          { required: true, message: "请选择发布范围", trigger: "blur" },
        ],
        content: [{ required: true, message: "请选择内容", trigger: "blur" }],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      activityId: "",
      recordFlag: true,
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    back() {
      this.recordFlag = true;
    },
    // 活动记录
    bindRecord(row) {
      this.activityId = row;
      this.recordFlag = false;
    },
    // 是否置顶
    updataStatus(row) {
      let data = {
        id: row.id,
        isTop: row.isTop ? 1 : -1,
      };
      this.$Apis.communityServiceTop(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    authorityList(row) {
      if (row.authority == -1) {
        return "全部";
      } else if (row.authority == 0) {
        return "业主";
      } else if (row.authority == 1) {
        return "亲属";
      } else if (row.authority == 2) {
        return "租客";
      } else if (row.authority == 3) {
        return "普通用户";
      }
    },
    typeList(row) {
      if (row.type == 1) {
        return "党史学习";
      } else if (row.type == 2) {
        return "公共服务";
      } else if (row.type == 3) {
        return "政务服务";
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.communityServiceDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            img: this.addData.img,
            detailImg: this.addData.detailImg,
            title: this.addData.title,
            type: this.addData.type,
            authority: this.addData.authority,
            content: this.addData.content,
          };
          this.$Apis.communityServiceAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.isShowloading = true;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm
      };
      this.$Apis.communityServiceList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.isTop = item.isTop == 1 ? true : false;
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>